module.exports = __webpack_public_path__ + "img/baifangda.3b2175ce.svg";